import React from "react";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Grid,
} from "@mui/material";
import { CustomStyles, IRadioGroupProps } from "./types";
import { useAppSelector } from "store/hooks/useAppSelector";
import { shallowEqual } from "react-redux";
import { styles } from "./MainRadioGroup.styled";

const MainRadioGroup: React.FC<IRadioGroupProps> = ({
  id,
  name,
  label,
  defaultValue,
  options = [],
  sx,
  columnCount,
  onChange,
}) => {
  const customStyles = styles as CustomStyles;
  const accentColor = useAppSelector(
    (state) => state.settings.config.accentColor,
    shallowEqual,
  );

  return (
    <Grid container spacing={2} sx={sx}>
      <FormControl component="fieldset">
        {label && (
          <FormLabel id={id} sx={styles.label}>
            {label}
          </FormLabel>
        )}
        <RadioGroup
          aria-labelledby={id}
          value={defaultValue}
          onChange={onChange}
          name={name}
          row
        >
          {options.map((input) => (
            <Grid
              item
              xs={columnCount?.xs}
              md={columnCount?.md}
              lg={columnCount?.lg}
              key={input.title}
              sx={styles.inputWrap(accentColor)}
            >
              <FormControlLabel
                sx={styles.title}
                value={input.value}
                control={
                  <Radio
                    icon={<Box component="span" sx={customStyles.customIcon} />}
                    checkedIcon={
                      <Box component="span" sx={customStyles.customCheckIcon}>
                        <Box
                          component="span"
                          sx={
                            typeof customStyles.checkDrop === "function"
                              ? customStyles.checkDrop(accentColor)
                              : {}
                          }
                        />
                      </Box>
                    }
                  />
                }
                label={input.title}
                disabled={false}
              />
            </Grid>
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};

export default MainRadioGroup;
